export enum ActionType {
    Void,
    Save,
    Submit
}
